import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import ItemVideo from './../atoms/ItemVideo'

const styles = () => ({
  root: {
    width: '100%',
    marginBottom: 40,
  },

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 16,
    gap: 16,
    flexWrap: 'wrap',
  },

  title: {
    margin: 0,
    fontFamily: 'var(--font-sans)',
    fontWeight: 600,
    fontSize: 18,
    lineHeight: '28px',
    letterSpacing: '-0.02em',
    color: '#002857',
  },

  subtitle: {
    margin: '2px 0 0 0',
    fontFamily: 'var(--font-sans)',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    color: '#305178',
  },

  explore: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    background: 'none',
    border: 'none',
    padding: 0,
    fontFamily: 'var(--font-sans)',
    fontWeight: 600,
    fontSize: 13,
    lineHeight: '18px',
    color: '#0C70E8',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    '&:hover': { textDecoration: 'underline' },
    '&:focus-visible': { outline: '2px solid rgba(12,112,232,.6)', outlineOffset: 2 },
  },

  row: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 24,
    '@media (max-width: 1279px)': {
      gridTemplateColumns: 'repeat(2, 1fr)',
      maxWidth: 604, // 2 × 290px cards + 24px gap — avoids dead space at embed widths
    },
    '@media (max-width: 640px)': {
      gridTemplateColumns: '1fr',
      maxWidth: 290,
    },
  },
})

// Landing-view row: one product group, first N cards, plus an
// "Explore the playlist" link into the expanded view.
function PlaylistRow({ classes, title, subtitle, videos, maxItems, onExplore, onPlay }) {
  const shown = Array.isArray(videos) ? videos.slice(0, maxItems) : []
  if (shown.length === 0) return null

  return (
    <section className={classes.root} aria-label={title}>
      <div className={classes.header}>
        <div>
          <h2 className={classes.title}>{title}</h2>
          {subtitle ? <p className={classes.subtitle}>{subtitle}</p> : null}
        </div>
        {typeof onExplore === 'function' && (
          <button type="button" className={classes.explore} onClick={onExplore}>
            Explore the playlist →
          </button>
        )}
      </div>
      <div className={classes.row}>
        {shown.map((v, i) => (
          <ItemVideo
            key={v.id || i}
            data={v}
            configData={{ anchorLinked: false, onclickedPbIcon: onPlay }}
          />
        ))}
      </div>
    </section>
  )
}

PlaylistRow.defaultProps = {
  videos: [],
  maxItems: 4,
  subtitle: '',
  onExplore: null,
  onPlay: null,
}

PlaylistRow.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  videos: PropTypes.array,
  maxItems: PropTypes.number,
  onExplore: PropTypes.func,
  onPlay: PropTypes.func,
}

export default withStyles(styles)(PlaylistRow)
